import { camelizeResponseData } from 'src/utilities/http-data-casing';
import { sdk } from 'src/utilities/sdk';
import { InsightReportsResponse } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/InsightsDashboard';

export const baseInsightsDashboardUrl =
  '/targetedaudiencesgateway/corp-admin/insights/dashboard';

export const getInsightsDashboardUrl = (corpId: string): string =>
  `${baseInsightsDashboardUrl}/${corpId}`;

export async function fetchInsightReports(
  corpId: string
): Promise<InsightReportsResponse> {
  const response = await sdk.http.get(getInsightsDashboardUrl(corpId));

  return camelizeResponseData(response) as InsightReportsResponse;
}
